import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
  <ReactPWAInstallProvider enableLogging>
    <App />
  </ReactPWAInstallProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
